if (!customElements.get("serum-how-to-use")) {
  customElements.define(
    "serum-how-to-use",
    class SerumHowToUse extends HTMLElement {
      constructor() {
        super();
        this.onVideoToggle = this.toggleVideo.bind(this);
        this.onVideoPlay = () => this.setVideoState(true);
        this.onVideoPause = () => this.setVideoState(false);
      }

      connectedCallback() {
        this.video = this.querySelector("video");
        this.videoButton = this.querySelector("[data-serum-how-to-video-toggle]");
        this.videoMedia = this.querySelector("[data-serum-how-to-video-media]");

        this.videoButton?.addEventListener("click", this.onVideoToggle);
        this.video?.addEventListener("play", this.onVideoPlay);
        this.video?.addEventListener("pause", this.onVideoPause);
        this.video?.addEventListener("ended", this.onVideoPause);

        if (this.video && !this.video.paused) this.setVideoState(true);
      }

      disconnectedCallback() {
        this.videoButton?.removeEventListener("click", this.onVideoToggle);
        this.video?.removeEventListener("play", this.onVideoPlay);
        this.video?.removeEventListener("pause", this.onVideoPause);
        this.video?.removeEventListener("ended", this.onVideoPause);
      }

      async toggleVideo() {
        if (!this.video) return;

        if (this.video.paused || this.video.ended) {
          try {
            await this.video.play();
          } catch (error) {
            this.setVideoState(false);
          }
        } else {
          this.video.pause();
        }
      }

      setVideoState(isPlaying) {
        this.videoMedia?.classList.toggle("is-playing", isPlaying);
        if (!this.videoButton) return;

        this.videoButton.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
        this.videoButton.setAttribute("aria-pressed", String(isPlaying));
      }
    }
  );
}
